<!--自定义发送帧组件-->
<template>
  <div class="custom-frames-group">
    <div class="cmp-handle">
      <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                            style="text-align: center">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div style="height: 100%">
      <div style="font-size: 16px;font-weight: bold">自定义帧</div>
      <el-button class="button" type="primary" @click="addFrame()" size="mini">添加</el-button>
      <el-table
          border
          class="table"
          :data="customFrames">
        <el-table-column
            align="center"
            label="ID"
            min-width="100">
          <template slot-scope="scope">
            <el-input
                type="text"
                placeholder="ID"
                size="small"
                clearable
                v-model="scope.row.msgId">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="Channel"
            min-width="110">
          <template slot-scope="scope">
            <el-select v-model="scope.row.canIndex" clearable placeholder="通道" size="small">
              <el-option
                  v-for="(item,index) in leftStructure[0].children.filter(list => list.type===0)"
                  :key="index"
                  :label="item.text"
                  :value="item.canIndex">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="Frame"
            min-width="110">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isExtend" clearable placeholder="类型" size="small">
              <el-option
                  v-for="(list,index) in isExtend"
                  :key="index"
                  :label="list.label"
                  :value="list.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            label="NoHup"
            align="center"
            min-width="60">
          <template slot-scope="scope">
            <el-checkbox
                size="small"
                v-model="scope.row.noHup">
            </el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
            label="BRS"
            align="center"
            min-width="50">
          <template slot-scope="scope">
            <el-checkbox
                size="small"
                v-model="scope.row.brs">
            </el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="DLC"
            min-width="85">
          <template slot-scope="scope">
            <el-select v-model="scope.row.dlc" placeholder="" size="small"
                       @change="setData(scope.row.dlc,scope.$index)">
              <el-option
                  v-for="index in 16"
                  :key="index-1"
                  :label="index-1"
                  :value="index-1+''">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="Data"
            :width="dataWidth()">
          <el-table-column
              :width="dataWidth()">
            <template slot="header" slot-scope="scope">
              <div v-for="index in maxData"
                   :key="index-1"
                   class="table-header">
                <span>{{index-1}}</span>
              </div>
            </template>
            <template slot-scope="scope">
              <el-input
                  class="data-input"
                  :maxlength="2"
                  type="text"
                  size="small"
                  v-model="scope.row.rawData[index]"
                  v-for="(item,index) in scope.row.rawData"
                  :key="index"
                  :value="item">
              </el-input>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
            align="center"
            label="SendNumber"
            min-width="140">
          <template slot-scope="scope">
            <el-input-number
                v-model="scope.row.sendNum"
                controls-position="right"
                :disabled="scope.row.noHup"
                :min="1"
                size="small"
                style="margin-right: 20px;width: 120px">
            </el-input-number>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="CycleTime"
            min-width="140">
          <template slot-scope="scope">
            <el-input style="margin-right: 20px;width: 120px"
                      v-model="scope.row.cycle"
                      placeholder="请输入发送周期"
                      size="small">
              <template slot="append">ms</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="操作"
            min-width="210">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="sendFrame(scope.$index)">发送</el-button>
            <el-button type="danger" size="mini" @click="stopSendFrame(scope.$index)">停止发送</el-button>
            <el-button
                @click.native.prevent="deleteFrame(scope.$index)"
                icon="el-icon-delete" style="color: #222222" type="text">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import projectDetailAPI from '@/api/projectDetail';

export default {
  name: 'CustomFrames',
  mounted() {
    this.getFrame();
  },
  data() {
    return {
      customFrames: [],
      isExtend: [{ value: false, label: '标准帧' }, { value: true, label: '扩展帧' }],
    };
  },
  props: {
    componentIndex: {
      type: Number,
    },
  },
  computed: {
    ...mapState('Engineering', ['leftStructure', 'panelDataCcg']),
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    // 最大数据场位数
    maxData() {
      let maxData = 1;
      for (let i = 0; i < this.customFrames.length; i++) {
        if (this.customFrames[i].rawData.length > maxData) {
          maxData = this.customFrames[i].rawData.length;
        }
      }
      return maxData;
    },
  },
  watch: {
  },
  methods: {
    ...mapMutations('Engineering', ['clickComponent', 'deleteComponent', 'addCustomFrame']),
    ...mapActions('Engineering', ['deleteCpt']),
    // 删除帧
    deleteFrame(index) {
      this.customFrames.splice(index, 1);
      this.saveFrame();
    },
    // 获取保存的数据
    getFrame() {
      const componentId = this.panelDataCcg[this.componentIndex].cid;
      projectDetailAPI.getFrame(componentId).then((res) => {
        // this.$message({
        //   message: "读取成功",
        //   type: "success"
        // });
        this.customFrames = res.definedDataParams;
      });
    },
    // 保存自定义帧组件信息
    saveFrame() {
      const deviceId = this.leftStructure[0].id;
      this.customFrames.map(item => item.deviceId = deviceId);
      const componentId = this.panelDataCcg[this.componentIndex].cid;
      console.log(`保存组件id为：${componentId}`);
      projectDetailAPI.saveFrame(componentId, this.customFrames).then(() => {
        // this.$message({
        //   message: "保存成功!",
        //   type: "success"
        // })
      }).catch(() => {
        this.$message.error('保存失败!');
      });
    },
    // 发送自定义帧
    sendFrame(index) {
      if (this.getCurCmpStatus) {
        this.saveFrame();
        const deviceId = this.leftStructure[0].id;
        this.customFrames[index].deviceId = deviceId;
        const frame = this.customFrames[index];
        if (frame.canIndex === '' || frame.canIndex === null) {
          this.$message.error('请正确填写CAN通道!');
        } else if (frame.msgId === '' || frame.msgId === null) {
          this.$message.error('请正确填写消息ID!');
        } else if (frame.dlc == 0) {
          this.$message.error('请正确填写自定义数据场!');
        } else {
          projectDetailAPI.sendFrame(frame).then(() => {
            this.$message({
              message: '发送成功',
              type: 'success',
            });
          }).catch(() => {
            this.$message.error('发送失败!');
          });
        }
      } else {
        this.$message({
          message: '面板尚未启动',
          type: 'info',
        });
      }
    },
    // 停止发送自定义帧
    stopSendFrame(index) {
      if (this.getCurCmpStatus) {
        this.saveFrame();
        const frame = {
          deviceId: this.leftStructure[0].id,
          canIndex: this.customFrames[index].canIndex,
          msgId: this.customFrames[index].msgId,
        };
        projectDetailAPI.stopSendFrame(frame).then(() => {
          this.$message({
            message: '已停止发送',
            type: 'success',
          });
        }).catch(() => {
          this.$message.error('停止发送失败!');
        });
      } else {
        this.$message({
          message: '面板尚未启动',
          type: 'info',
        });
      }
    },
    // 添加一条自定义帧
    addFrame() {
      const frame = {
        deviceId: this.leftStructure[0].id,
        canIndex: 0,
        isExtend: '',
        msgId: '',
        noHup: false,
        isRemote: false,
        brs: false,
        dlc: 0,
        rawData: [],
        sendNum: 1,
        cycle: 100,
      };
      this.customFrames.push(frame);
      this.saveFrame();
      // const {customFrames ,componentIndex } = this
      // this.addCustomFrame({customFrames ,componentIndex })
    },
    // 由DLC的值确定数据场位数
    dlcToData(dlc) {
      let length = 0;
      switch (dlc) {
        case '9':
          length = 12;
          break;
        case '10':
          length = 16;
          break;
        case '11':
          length = 20;
          break;
        case '12':
          length = 24;
          break;
        case '13':
          length = 32;
          break;
        case '14':
          length = 48;
          break;
        case '15':
          length = 64;
          break;
        default :
          length = dlc;
          break;
      }
      return length;
    },
    // 生成数据场
    setData(dlc, row) {
      const data = this.dlcToData(dlc);
      this.customFrames[row].rawData = [];
      for (let i = 0; i < data; i++) {
        this.customFrames[row].rawData.push('');
      }
    },
    // 根据数据场位数动态生成Data宽度
    dataWidth() {
      return this.maxData * 54 + 22;
    },
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  @import "../../style/mixin";

  /*.table{*/
  /*  height: 80%;*/
  /*  overflow: auto;*/
  /*  border:0px;*/
  /*  background-color: rgba(127,204,232,0);*/
  /*}*/

  .button {
    float: right;
    display: flex;
    padding: 12px 20px;
    margin: 20px 0px;
  }

  .table-header {
    width:50px;
    height:25px;
    margin-left:2px;
    margin-right: 2px;
    text-align: center;
    float:left;
  }

  .data-input{
    width: 50px;
    height: auto;
    margin-right: 2px;
    margin-left: 2px
  }

  .custom-frames-group {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px;

    .cmp-handle {
      position: absolute;
      top: 0;
      right: 0;

      .el-input__icon {
        line-height: 25px;
      }
    }

    &:hover {
      animation: 1s shadowChange infinite;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/engineering/CustomFrames.vue